import { Fragment } from 'react';

import useClubAthleteRoster from './UseClubAthleteRoster';

import ClubAthleteRosterFormGrid from './ClubAthleteRosterFormGrid';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import { LOADING_MSG, SAVING_MSG } from '@usas/ui-web/utils/Constants';

const ClubAthleteRoster = () => {
  const {
    isSaving,
    isLoading,
    isGridLoading,
    state,
    clubRosterVendorSyncState,
    clubObj,
    clubAddressObj,
    clubRosterArray,
    onEditAthlete,
    onSubmitAthleteFilter,
    onSubmitAthleteSync,
    onSubmitAthleteTransfer
  } = useClubAthleteRoster();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Athlete Roster</Headings.H3>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12">
          {clubRosterVendorSyncState.isSaved === true && <p style={{ fontSize: 24, color: 'slategray' }}>{clubRosterVendorSyncState.objData.toString()} Athletes Synced</p>}
        </div>
      </div>
      <ClubAthleteRosterFormGrid
        clubObj={clubObj}
        clubAddressObj={clubAddressObj}
        clubRosterArray={clubRosterArray}
        isLoading={isGridLoading}
        onEditAthlete={onEditAthlete}
        onSubmitAthleteFilter={onSubmitAthleteFilter}
        onSubmitAthleteSync={onSubmitAthleteSync}
        onSubmitAthleteTransfer={onSubmitAthleteTransfer}
        PRACTICE_GROUP_TYPE_ID={state.practiceGroupTypeId}
        SITE_GROUP_TYPE_ID={state.siteGroupTypeId} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={LOADING_MSG}
        displayPopUp={isLoading} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={SAVING_MSG}
        displayPopUp={isSaving} />
    </Fragment>
  );
};

export default ClubAthleteRoster;
